export default {"src":"https://fishbrain.com/_next/static/media/california.f243d6ef.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};